import { render, staticRenderFns } from "./TheRecipientsAddressBookCheckbox.vue?vue&type=template&id=57f920bf&scoped=true"
import script from "./TheRecipientsAddressBookCheckbox.vue?vue&type=script&lang=js"
export * from "./TheRecipientsAddressBookCheckbox.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsAddressBookCheckbox.vue?vue&type=style&index=0&id=57f920bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f920bf",
  null
  
)

export default component.exports